import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { marketingUrl } from '../../lib/marketingUrls';
import LanguageSelect from '../LanguageSelect';

const InviteLayout: React.FC = () => {
  const { t } = useLanguage();

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'mySign.az';

    let meta = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    let created = false;
    const previousContent = meta?.getAttribute('content') ?? null;
    if (!meta) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
      created = true;
    }
    meta.content = 'noindex, nofollow';

    return () => {
      document.title = previousTitle;
      if (!meta) return;
      if (created) {
        meta.remove();
        return;
      }
      if (previousContent == null) meta.removeAttribute('content');
      else meta.content = previousContent;
    };
  }, []);

  return (
    <div className="flex min-h-dvh flex-col bg-[#f5f5f5] text-neutral-900">
      <header className="border-b border-neutral-200 bg-white">
        <div className="mx-auto flex h-14 w-full max-w-[600px] items-center justify-between gap-3 px-4">
          <a
            href={marketingUrl('/')}
            className="inline-flex min-w-0 items-center gap-2.5 text-foreground"
          >
            <span
              className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-primary text-sm font-bold tracking-[-0.08em] text-primary-foreground"
              aria-hidden
            >
              mS
            </span>
            <span className="truncate text-lg font-semibold tracking-tight">
              mySign<span className="text-primary">.az</span>
            </span>
          </a>
          <LanguageSelect triggerClassName="h-11 w-[118px] px-2 text-sm" />
        </div>
      </header>
      <main className="mx-auto flex w-full max-w-[600px] flex-1 flex-col px-4 py-5">
        <Outlet />
      </main>
      <footer className="border-t border-neutral-200 bg-white">
        <div className="mx-auto flex w-full max-w-[600px] flex-col items-center gap-2 px-4 py-5 text-center text-xs text-neutral-600">
          <p>{t('footerCopyright')}</p>
          <nav aria-label={t('signLinkFooterNav')} className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <a href={marketingUrl('/about')} className="inline-flex min-h-11 items-center hover:text-neutral-900 hover:underline">
              {t('aboutUs')}
            </a>
            <a
              href={marketingUrl('/about#privacy')}
              className="inline-flex min-h-11 items-center hover:text-neutral-900 hover:underline"
            >
              {t('signLinkPrivacy')}
            </a>
            <a href={marketingUrl('/contact')} className="inline-flex min-h-11 items-center hover:text-neutral-900 hover:underline">
              {t('contactUs')}
            </a>
          </nav>
        </div>
      </footer>
    </div>
  );
};

export default InviteLayout;
